import { 
  CalendarDays, Calculator, FolderOpen, Users, FileSignature, 
  BarChart3, Megaphone, Settings, LayoutGrid 
} from 'lucide-react';

/**
 * Inteligência: Retorna o ícone do Lucide com base no título do módulo
 * @param {string} title 
 * @returns {React.Component}
 */
export const getDynamicIcon = (title) => {
    const t = String(title).toLowerCase();
    if (t.includes('ponto') || t.includes('frequência') || t.includes('cronograma')) return CalendarDays;
    if (t.includes('holerite') || t.includes('pagamento') || t.includes('folha') || t.includes('irpf')) return Calculator;
    if (t.includes('doc') || t.includes('arquivo') || t.includes('ged') || t.includes('protocolo')) return FolderOpen;
    if (t.includes('usuário') || t.includes('pessoa') || t.includes('cliente')) return Users;
    if (t.includes('contrato') || t.includes('assinatura')) return FileSignature;
    if (t.includes('avalia') || t.includes('desempenho') || t.includes('meta') || t.includes('indicador')) return BarChart3;
    if (t.includes('comunic') || t.includes('aviso') || t.includes('mkt') || t.includes('boletim')) return Megaphone;
    if (t.includes('adm') || t.includes('config')) return Settings;
    return LayoutGrid;
};

/**
 * Extrai recursivamente todos os caminhos de chaves de um objeto JSON
 * @param {object} obj 
 * @param {string} prefix 
 * @returns {string[]}
 */
export const extractJsonPaths = (obj, prefix = '') => {
    let paths = [];
    for (const key in obj) {
        if (obj[key] !== null && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
            paths = paths.concat(extractJsonPaths(obj[key], `${prefix}${key}.`));
        } else {
            paths.push(`${prefix}${key}`);
        }
    }
    return paths.sort();
};

/**
 * Busca valores em caminhos complexos separados por ponto (ex: "attributes.nome")
 * @param {object} obj 
 * @param {string} path 
 * @returns {*}
 */
export const getNestedValue = (obj, path) => {
    if (!path || !obj) return undefined;
    return path.split('.').reduce((o, i) => (o ? o[i] : undefined), obj);
};
